import React, { useEffect, useState } from 'react';
import EcranPassage from './connexion/EcranPassage';
import { lireEcrans, momentPour, segments } from './connexion/contenusEcrans';

/**
 * Écran d'au revoir du kiosque de pointage : la même école qui s'endort que
 * pour l'administration, sans nom de personne.
 * Ancienne version : components/dump/KiosqueGoodbyeScreen-V1-avant-refonte.jsx
 */
const KiosqueGoodbyeScreen = () => {
  const [ecrans] = useState(lireEcrans);
  const [moment] = useState(() => momentPour(ecrans.horaires));

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.location.href = '/connexion';
    }, 2500);

    return () => clearTimeout(timeout);
  }, []);

  const textes = ecrans.au_revoir_kiosque;

  return (
    <EcranPassage
      sens="depart"
      moment={moment}
      titre={segments(textes[moment], {}, [])}
      phrase={segments(textes.fin, {}, [])}
      icone="sortie"
      duree={2.5}
    />
  );
};

export default KiosqueGoodbyeScreen;
